import React from 'react';

import styles from './LoaderPage.module.css';

const LoaderPage = () => {
  return (
    <div className={styles.loader_wrapper}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default LoaderPage;
